import { XCircleIcon } from "@heroicons/react/24/solid";
import "./styles/ClearIcon.scss";
const ClearIcon = () => {
    return <XCircleIcon className="icon--xs clear__icon" />;
};
export default ClearIcon;
